<template>
  <div class="checkbox" :class="inverted ? 'reversed' : ''">
    <input type="checkbox" class="inv_input" :id="id"
      @input="toggleState" v-model="localModelValue">
    <div class="checkbox_checkbox" :class="localModelValue ? 'checked' : ''" @click="toggleState">
    </div>
    <label class="checkbox_label" :for="id">{{ text }}</label>
  </div>
</template>
<script>
export default {
  name: 'checkbox',
  model: {
    prop: 'modelValue',
    event: 'input',
  },
  props: {
    modelValue: Boolean,
    id: {
      type: String,
      required: false,
      default: 'checkBox',
    },
    text: {
      type: String,
      required: true,
    },
    inverted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {};
  },
  methods: {
    sendState() {
      this.$emit('input', this.checked);
    },
    toggleState() {
      this.localModelValue = !this.modelValue;
      this.sendState();
    },
  },
  computed: {
    localModelValue: {
      get() { return this.modelValue; },
      set(value) { this.$emit('update:modelValue', value); },
    },
  },
  mounted() {
    this.checked = this.modelValue;
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.checkbox{
  display: flex;
  align-items: center;
  font-family: $font;
  color: white;
  font-size: 16px;
  &.reversed{
    flex-direction: row-reverse;
    align-items: center;
    justify-content: start;
    .checkbox_label{
      margin-right: 10px;
      margin-left: 0;
      min-width: 113px;
    }
  }
  &_checkbox{
    height: 25px;
    width: 25px;
    border-radius: 8px;
    background: $black;
    box-shadow: 1px 1px 5px 1px #333;
    cursor: pointer;
    &.checked{
      position: relative;
      &:after{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        content: '\f00c';
        font-family: 'FontAwesome';
        color: $green;
        font-size: 20px;
      }
    }
  }
  &_label{
    color: white;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/checkBox.vue